import { CalendarDate, now, toCalendarDate } from '@internationalized/date';
import { ComponentProps } from 'react';

import YearCalendar from '../YearCalendar/YearCalendar';

type YearViewProps = {
    defaultFocusedDate?: CalendarDate;
    value?: CalendarDate | null;
    onChange: (focusDate: CalendarDate) => void;
    timeZone: string;
    numYears?: number;
} & Omit<ComponentProps<typeof YearCalendar>, 'focusedDate' | 'numYears'>;

const YearView = ({
    defaultFocusedDate,
    timeZone,
    numYears = 12,
    ...props
}: YearViewProps) => {
    const nowValue = toCalendarDate(now(timeZone));

    return (
        <YearCalendar
            numYears={numYears}
            focusedDate={defaultFocusedDate ?? nowValue}
            timeZone={timeZone}
            {...props}
        />
    );
};

export default YearView;
